/**
 * Open Razorpay checkout popup and return payment response.
 * @param {Object} opts
 * @param {string} opts.order_id - Razorpay order ID
 * @param {number} opts.amount - Amount in paise
 * @param {string} opts.currency - Currency code (INR)
 * @param {string} opts.key_id - Razorpay public key
 * @param {string} opts.name - Display name on checkout
 * @param {string} opts.description - Payment description
 * @param {Object} opts.prefill - {name, email, contact}
 * @returns {Promise<{razorpay_payment_id, razorpay_order_id, razorpay_signature}>}
 */
export function openRazorpayCheckout({ order_id, amount, currency, key_id, name, description, prefill }) {
  return new Promise((resolve, reject) => {
    const options = {
      key: key_id || process.env.REACT_APP_RAZORPAY_KEY_ID,
      amount,
      currency: currency || 'INR',
      name: name || 'Connect',
      description: description || 'Payment',
      order_id,
      handler: (response) => resolve(response),
      modal: { ondismiss: () => reject(new Error('Payment cancelled')) },
      prefill: prefill || {},
      theme: { color: '#000000' },
    };
    const rzp = new window.Razorpay(options);
    rzp.on('payment.failed', (resp) => reject(new Error(resp.error?.description || 'Payment failed')));
    rzp.open();
  });
}
